// extracted by mini-css-extract-plugin
module.exports = {"Video":"_3eV9nPypxjwx-yPQCE3HEM"};